import './Layout.css';
import React from 'react';
import { Typography } from 'antd';

const Layout = ({ title, description, children }) => {
    return (
        <div>
            <div className="header-container">
                <div className="header-content">
                    <Typography.Text className="section-label">{title}</Typography.Text>
                    {description && <Typography.Text className="section-description">{description}</Typography.Text>}
                </div>
            </div>
            {children}
        </div>
    );
};

export default Layout;